<script setup>
import {computed, onMounted, ref} from "vue";
import {usePiniaStore} from "../store/pinia_store";
import _, {isEmpty} from "lodash";

const props = defineProps({
    crmId: {
        required: true
    },
    dentaidApiInstance: {
        required: true
    },
    eventBus: {
        type: Object,
        required: true,
    },
    cartEventBus: {
        type: Object,
        required: true,
    },
    brandTitle: {
        type: String,
        required: true,
    },
    productTitle: {
        type: String,
        required: true,
    },
    productId: {
        type: String,
        required: true,
    },
})

const piniaStore = usePiniaStore();

const freeUnit = ref(false);
const incrementalOrderQuantity = ref(null);
const cnkCode = ref(null);
const minimalOrderQuantity = ref(null);
const loaded = ref(false);

const language = ref(window.drupalSettings.ef2_custom.language);

const fetchProductData = async function () {
    if (isEmpty(drupalSettings.ef2_custom.customer_number)) {
        loaded.value = true;

        return;
    }

    return await props.dentaidApiInstance.post(`/prices?token=${piniaStore.parsedToken}`, {
        items: {
            "0": {
                sku: props.crmId,
            }
        }
    })
        .then(response => {
            incrementalOrderQuantity.value = response.data[props.crmId].incremental_order_quantity;
            minimalOrderQuantity.value = response.data[props.crmId].min_order_quantity;
            cnkCode.value = response.data[props.crmId].cnk_code;
        }).finally(() => loaded.value = true)
}

onMounted(() => {
    fetchProductData();
})
</script>

<template>
    <div class="vue-product-components-wrapper" v-if="loaded">
        <div class="price-tooltip-wrapper">
            <dentaid-product-price
                v-if="loaded"
                :crm-id="crmId"
                :dentaid-api-instance="dentaidApiInstance"
                :event-bus="eventBus"
                :order-unit="incrementalOrderQuantity"
            ></dentaid-product-price>

            <template v-if="freeUnit">
                <slot name="tooltip-wrapper"></slot>
            </template>
        </div>

        <slot name="default-content"></slot>

        <template>
            <dentaid-product-quantity
                v-if="loaded"
                :event-bus="eventBus"
                :crm-id="crmId"
                :incremental-order-quantity="incrementalOrderQuantity"
                :minimum-order-quantity="minimalOrderQuantity"
            ></dentaid-product-quantity>

            <div class="d-flex mb-5 align-items-center product-buttons">
                <dentaid-add-to-cart
                    :event-bus="eventBus"
                    :crm-id="crmId"
                    :dentaid-api-instance="dentaidApiInstance"
                    :cart-event-bus="cartEventBus"
                    :brand-title="brandTitle"
                    :product-title="productTitle"
                    :product-id="productId"
                    :minimum-order-quantity="minimalOrderQuantity"
                ></dentaid-add-to-cart>

                <dentaid-product-favorite
                    :crm-id="crmId"
                    :event-bus="eventBus"
                    :dentaid-api-instance="dentaidApiInstance"
                ></dentaid-product-favorite>
            </div>
        </template>
    </div>
</template>
